import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

const Welcome = () => import('@/pages/Welcome')
const Dashboard = () => import('@/pages/Dashboard')
const Login = () => import('@/pages/Login')
const Reset = () => import('@/pages/Reset')
const Mapping = () => import('@/pages/Mapping')
const Requests = () => import('@/pages/Requests')
const Dispatches = () => import('@/pages/Dispatches')
const Notifications = () => import('@/pages/Notifications')
const Account = () => import('@/pages/Account')
const Settings = () => import('@/pages/Settings')
const Vehicles = () => import('@/pages/Vehicles')
const Employees = () => import('@/pages/Employees')
const Partners = () => import('@/pages/Partners')
// import Rides from '@/pages/Rides'

Vue.use(Router)

function getPerms(info) {
  let result = {
    dis: false,
    empl: false,
    notif: false,
    partn: false,
    req: false,
    track: false,
    veh: false,
    dash: false,
  };

  if (info.permissions == null) return result;

  let perms = info.permissions.split(',');
  // Dispatches
  result.dis = perms.indexOf('dispatch:all') > -1 || perms.indexOf('dispatch:read') > -1;
  // Employees
  result.empl = perms.indexOf('user:all') > -1 || perms.indexOf('user:read') > -1;
  // Notifications
  result.notif = perms.indexOf('notification:all') > -1 || perms.indexOf('notification:read') > -1;
  // Partners
  result.partn = perms.indexOf('company:all') > -1 || perms.indexOf('company:read') > -1;
  // Requests
  result.req = perms.indexOf('request:all') > -1 || perms.indexOf('request:read') > -1;
  // Tracking
  result.track = perms.indexOf('tracking:all') > -1 || perms.indexOf('tracking:read') > -1;
  // Vehicles
  result.veh = perms.indexOf('vehicle:all') > -1 || perms.indexOf('vehicle:read') > -1;
  // Dashboard
  result.dash = perms.indexOf('dashboard:all') > -1 || perms.indexOf('dashboard:read') > -1;

  return result;
}

const ifNotAuthenticated = (to, from, next) => {
  if (store.getters['login/status']) {
    next('/dashboard');
    return;
  }

  document.title = to.meta.title;
  next();
}

const ifAuthenticated = (to, from, next) => {
  if (!store.getters['login/status']) {
    switch (to.path) {
      default:
        next('/login');
        break;
    }
  }

  let forbidden = false,
    perms = getPerms(store.getters['login/info']);

  switch (to.path) {
    case '/dashboard':
      forbidden = !perms.dash;
      break;
    case '/tracking':
      forbidden = !perms.track;
      break;
    case '/notifications':
      forbidden = !perms.notif;
      break;
    case '/requests':
      forbidden = !perms.req;
      break;
    case '/dispatches':
      forbidden = !perms.dis;
      break;
    case '/vehicles':
      forbidden = !perms.veh;
      break;
    case '/employees':
      forbidden = !perms.empl;
      break;
    case '/partners':
      forbidden = !perms.partn;
      break;
  }

  if (forbidden) {
    next('/account');
    return;
  }

  document.title = to.meta.title;
  next();
  return;
}

const reroute = (to, from, next) => {
  if (store.getters['login/status']) {
    next('/account');
    return;
  }
  next('/login');
}

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Welcome',
    beforeEnter: reroute,
    meta: {
      title: 'Welcome - joinETA',
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    beforeEnter: ifAuthenticated,
    meta: {
      title: 'Dashboard - joinETA',
    }
  },
  {
    path: '/tracking',
    name: 'Mapping',
    component: Mapping,
    beforeEnter: ifAuthenticated,
    meta: {
      title: 'Tracking - joinETA',
    }
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: Notifications,
    beforeEnter: ifAuthenticated,
    meta: {
      title: 'Notification center - joinETA',
    }
  },
  {
    path: '/requests',
    name: 'Requests',
    component: Requests,
    beforeEnter: ifAuthenticated,
    meta: {
      title: 'Service call center - joinETA',
    }
  },
  {
    path: '/dispatches',
    name: 'Dispatches',
    component: Dispatches,
    beforeEnter: ifAuthenticated,
    meta: {
      title: 'Dispatch center - joinETA',
    }
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    beforeEnter: ifAuthenticated,
    meta: {
      title: 'Account - joinETA',
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    beforeEnter: ifAuthenticated,
    meta: {
      title: 'Settings - joinETA',
    }
  },
  {
    path: '/vehicles',
    name: 'Vehicles',
    component: Vehicles,
    beforeEnter: ifAuthenticated,
    meta: {
      title: 'Vehicle center - joinETA',
    }
  },
  {
    path: '/employees',
    name: 'Employees',
    component: Employees,
    beforeEnter: ifAuthenticated,
    meta: {
      title: 'Employee center - joinETA',
    }
  },
  {
    path: '/partners',
    name: 'Partners',
    component: Partners,
    beforeEnter: ifAuthenticated,
    meta: {
      title: 'Partner center - joinETA',
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: ifNotAuthenticated,
    meta: {
      title: 'Login - joinETA',
    }
  },
  {
    path: '/reset',
    name: 'Reset',
    component: Reset,
    beforeEnter: ifNotAuthenticated,
    meta: {
      title: 'Reset Credentials - joinETA',
    }
  },
  ]
})
